import { FilterOperator } from '@nemuru-eng/js-api-client';

import { DateMap } from '@/components/shared/components/SuperSearchBar/maps/DateMap';
import { OrderMap } from '@/components/shared/components/SuperSearchBar/maps/OrderMap';
import { FilterByDate } from '@/components/shared/components/SuperSearchBar/types/FilterByDate';
import { SearchListFilter } from '@/components/shared/components/SuperSearchBar/types/SearchListFilter';
import { SortByType } from '@/components/shared/components/SuperSearchBar/types/SortByType';
import { adjustDateTimeByTimezoneOffset, setDateTimeToZero } from '@/utils/timeFormatters';

export const getDateSearchFilters = (filterByDate: FilterByDate, sortBy: SortByType): SearchListFilter => {
  if (filterByDate === FilterByDate.ALL_DATES) return [];

  const currentDate = new Date();
  const numberOfDaysByFilter = DateMap.fromDateFilter(filterByDate);
  const adjustedDate = currentDate.setDate(currentDate.getDate() - numberOfDaysByFilter);

  return [
    {
      field: OrderMap.fromSortBy(sortBy),
      operator: FilterOperator.LTE,
      value: adjustDateTimeByTimezoneOffset(new Date()),
    },
    {
      field: OrderMap.fromSortBy(sortBy),
      operator: FilterOperator.GTE,
      value: adjustDateTimeByTimezoneOffset(setDateTimeToZero(adjustedDate)),
    },
  ];
};
